
function generateAccessibilityLiveRegionElement(message = "",type = "assertive"){
    const idLiveRegionElement = "accessibility-live-region";

    if(document.getElementById(idLiveRegionElement)){
        document.getElementById(idLiveRegionElement).remove();
    }

    const liveRegionElement = document.createElement("div");
    liveRegionElement.setAttribute("id",idLiveRegionElement);
    liveRegionElement.setAttribute("aria-live",type);
    liveRegionElement.setAttribute("style","position: absolute; left: -9999px");
    liveRegionElement.innerText = message;
    document.body.prepend(liveRegionElement);
    console.info("Live Region Message: " + message);
}

export function setAccessibilityLiveRegionMessage(message = "", type = "assertive"){
    generateAccessibilityLiveRegionElement(message,type);
}